import { render, staticRenderFns } from "./DatesCommentsAndDiscounts.vue?vue&type=template&id=24728c37"
import script from "./DatesCommentsAndDiscounts.vue?vue&type=script&lang=js"
export * from "./DatesCommentsAndDiscounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports